import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Grid,
  Box,
  Typography,
  CircularProgress,
  Collapse,
  Divider
} from "@mui/material";
import { Add, Edit, Delete, AddAPhoto } from "@mui/icons-material";
import {
  getallSitesData,
  getSiteContactsbySiteID,
  insertSiteContact,
  insertSiteData,
  updateSiteById,
} from "../../api/sites";
import { useDispatch, useSelector } from "react-redux";
import { showAlert, showSuccess } from "../../actions/alert";
import { updateExpensebyID } from "../../api/expensesManagement";
import { getVendorList } from "../../api/vendor";
import AddIcon from "@mui/icons-material/Add";
import InfoIcon from "@mui/icons-material/Info";
import { handleAxiosError } from "../../config/action-config";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const initialContact = {
  id: null,
  site_id: "",
  vendor: "",
  role: "",
  phone: "",
  email: "",
  company: "",
  notes: "",
};

export default function SiteContacts() {
  const user = useSelector((state) => state.user);
  const [contacts, setContacts] = useState([]);
  const [formData, setFormData] = useState(initialContact);
  const [open, setOpen] = useState(false);
  const [openSiteContact, setOpenSiteContact] = useState(false);
  const [contactData, setContactData] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const dispatch = useDispatch();
  const [expandedRows, setExpandedRows] = useState({});
  const [subTableData, setSubTableData] = useState({});
  const [loadingRows, setLoadingRows] = useState({});
  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });
  const handleContactChange = (e) =>
    setContactData({ ...contactData, [e.target.name]: e.target.value });

  const handleSave = async () => {
    if (editMode) {
      try {
        const { data } = await updateSiteById(
          formData,
          user.token,
          formData.site_id
        );
        if (data.status) {
          setFormData(initialContact);
          FetchAllSites();
          // showSuccess("Contact saved successfully");
          dispatch(showAlert("Contact saved successfully"));
        }
      } catch (error) {
        console.error("Error saving contact:", error);
        handleAxiosError(error, dispatch);
      }
    } else {
      try {
        const { data } = await insertSiteData(formData, user.token);
        if (data.status) {
          setFormData(initialContact);
          // showSuccess("Contact saved successfully");
          dispatch(showAlert("Contact saved successfully"));
          FetchAllSites();
        }
      } catch (error) {
        handleAxiosError(error, dispatch);

        console.error("Error saving contact:", error);
      }
    }
    setOpen(false);
  };

  const FetchContactbySites = async () => {
    try {
      const { data } = await getSiteContactsbySiteID(
        // { projectId: projectId },
        user.token
      );
      if (data.status) {
        setContacts(data.data);
      }
    } catch (error) {
      console.error("Error fetching all sites:", error);
    }
  };
  const [vendorList, setVendorList] = useState([]);

  useEffect(() => {
    getVendorList(user.token).then((res) => {
      setVendorList(res.data.data);
    });
  }, []);
  const handleEdit = (contact) => {
    setFormData(contact);
    setEditMode(true);
    setOpen(true);
  };

  const handleAdd = (data) => {
    setOpenSiteContact(true);

    const { address, ...rest } = data;
    setContactData(rest);
  };

  useEffect(() => {
    FetchAllSites();
  }, [user.token]);

  const FetchAllSites = async () => {
    try {
      const { data } = await getallSitesData(
        // { projectId: projectId },
        user.token
      );
      if (data.status) {
        setContacts(data.data);
      }
    } catch (error) {
      console.error("Error fetching all sites:", error);
    }
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    try {
      const { data } = await insertSiteContact(user.token, contactData);
      if (data.status) {
        setOpenSiteContact(false);
        dispatch(showAlert("Contact Added successfully"));
      }
    } catch (error) {
      console.error("Error saving contact:", error);
      handleAxiosError(error, dispatch);
    }
  };
  const handleToggleSubTable = async (id) => {
    const isOpen = expandedRows[id];

    if (isOpen) {
      setExpandedRows((prev) => ({ ...prev, [id]: false }));
    } else {
      setLoadingRows((prev) => ({ ...prev, [id]: true }));
      try {
        const { data } = await getSiteContactsbySiteID(user.token, id);
        if (data.status) {
          setSubTableData((prev) => ({ ...prev, [id]: data.data }));
          setExpandedRows((prev) => ({ ...prev, [id]: true }));
        }
      } catch (err) {
        console.error("Error fetching sub table:", err);
      } finally {
        setLoadingRows((prev) => ({ ...prev, [id]: false }));
      }
    }
  };
  return (
    <>
      <Box className="pmt-title-box">
        <Box className="typography-title">
          <Typography variant="h1" className="pmt-headings-h1">
            Sites
          </Typography>
        </Box>
        <Button
          variant="contained"
          startIcon={<Add />}
          onClick={() => {
            setFormData(initialContact);
            setEditMode(false);
            setOpen(true);
          }}
          className="blue-button"
        >
          Add New Site
        </Button>
      </Box>

      <TableContainer component={Paper} sx={{ mt: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Actions</TableCell>
              <TableCell>Site</TableCell>
              {/* <TableCell>Vendor Name</TableCell> */}
              <TableCell>Address</TableCell>
              <TableCell>Created BY</TableCell>
              <TableCell>Created Date</TableCell>
              {/* <TableCell>Company</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {contacts.map((site) => (
                <React.Fragment key={site.site_id}>
              <TableRow key={site.site_id}>
                <TableCell>
                  <IconButton onClick={() => handleEdit(site)}>
                    <Edit />
                  </IconButton>
                  <IconButton
                    title="Edit Site"
                    arrow
                    onClick={() => handleAdd(site)}
                  >
                    <AddIcon />
                  </IconButton>
                  <IconButton
                    color="info"
                    onClick={() => handleToggleSubTable(site.site_id)}
                  >
                    {expandedRows[site.site_id] ? (
                      <VisibilityOffIcon fontSize="small" />
                    ) : (
                      <VisibilityIcon fontSize="small" />
                    )}
                  </IconButton>
                </TableCell>
                <TableCell>{site.site_name}</TableCell>
                {/* <TableCell>{site.vendor_name}</TableCell> */}
                <TableCell>{site.address}</TableCell>
                <TableCell>{site.created_by}</TableCell>
                <TableCell>{site.created_date}</TableCell>
                {/* <TableCell>{contact.company}</TableCell> */}
              </TableRow>
                  <TableRow>
                                              <TableCell colSpan={7} sx={{ p: 0, bgcolor: "#f8f9fa" }}>
                                                <Collapse
                                                  in={expandedRows[site.site_id]}
                                                  timeout="auto"
                                                  unmountOnExit
                                                >
                                                  <Box sx={{ p: 3 }}>
                                                    {loadingRows[site.site_id] ? (
                                                      <Box
                                                        sx={{
                                                          display: "flex",
                                                          justifyContent: "center",
                                                          alignItems: "center",
                                                          py: 4,
                                                        }}
                                                      >
                                                        <CircularProgress size={32} />
                                                        <Typography sx={{ ml: 2 }}>
                                                          Loading Expense details...
                                                        </Typography>
                                                      </Box>
                                                    ) : (
                                                      <Box style={{ zoom: "0.75" }}>
                                                        <Typography
                                                          variant="h6"
                                                          sx={{ mb: 2, color: "primary.main" }}
                                                        >
                                                          Site Details for {site.site_name}
                                                        </Typography>
                                                        <Divider sx={{ mb: 2 }} />
                            
                                                      {(subTableData[site.site_id] || []).length === 0 ? (
                <Box
                  sx={{
                    textAlign: "center",
                    py: 4,
                    color: "text.secondary",
                  }}
                >
                  <Typography variant="body1">
                    No  contacts found for this site
                  </Typography>
                </Box>
              ) : (
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell><strong>Site Contact Name</strong></TableCell>
                        <TableCell><strong>Email</strong></TableCell>
                        {/* <TableCell><strong>Type</strong></TableCell> */}
                        <TableCell><strong>Phone No</strong></TableCell>
                        <TableCell><strong>Address</strong></TableCell>
                        {/* <TableCell><strong>Notes</strong></TableCell> */}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(subTableData[site.site_id] || []).map((s, idx) => (
                        <TableRow key={idx} hover>
                          {/* Expense Name */}
                          <TableCell>
                            <Typography variant="body2" sx={{ fontWeight: 600 }}>
                              {s.site_contact_name}
                            </Typography>
                          </TableCell>
              
                          {/* Site Type */}
                          <TableCell>
                          <Typography variant="body2" sx={{ fontWeight: 600 }}>
                              {s.email}
                            </Typography>
                          </TableCell>
              
                          {/* Manager */}
                          <TableCell>
                            <Typography variant="body2" sx={{ fontWeight: 600 }}>
                              {s.phone_no}
                            </Typography>
                          </TableCell>
              
                          {/* Duration */}
                          <TableCell>
                            <Typography variant="body2" sx={{ fontWeight: 600 }}>
                              {s.address}
                            </Typography>
                          </TableCell>
              
              
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
              
                                                      </Box>
                                                    )}
                                                  </Box>
                                                </Collapse>
                                              </TableCell>
                                            </TableRow>
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>{editMode ? "Edit Site" : "Add Site"}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            {/* <Grid item xs={12} sm={6}>
        <FormControl fullWidth>
          <InputLabel>Site</InputLabel>
          <Select
            name="siteId"
            value={formData.siteId}
            onChange={handleChange}
            label="Site"
          >
            <MenuItem value=""><em>Select Site</em></MenuItem>
            {mockSites.map(site => (
              <MenuItem key={site.site_id} value={site.site_id}>{site.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid> */}

            <Grid item xs={12} sm={6}>
              <TextField
                name="site_name"
                label="Site Name"
                fullWidth
                value={formData.site_name}
                onChange={handleChange}
              />
            </Grid>
            {/*
      <Grid item xs={12} sm={6}>
        <TextField
          name="role"
          label="Role"
          fullWidth
          value={formData.role}
          onChange={handleChange}
        />
      </Grid> */}

            {/* <Grid item xs={12} sm={6}>
        <TextField
          name="phone"
          label="Phone"
          fullWidth
          value={formData.phone}
          onChange={handleChange}
        />
      </Grid> */}

            {/* <Grid item xs={12} sm={6}>
        <TextField
          name="email"
          label="Email"
          fullWidth
          value={formData.email}
          onChange={handleChange}
        />
      </Grid> */}
            {/*
      <Grid item xs={12} sm={6}>
        <TextField
          name="vendor"
          label="Vendor Name"
          fullWidth
          value={formData.vendor}
          onChange={handleChange}
        />
      </Grid> */}
            <Grid item xs={12} sm={6}>
              {/* <FormControl
              margin="dense"
              fullWidth
              required
              // error={Boolean(errors.vendor_id)}
            >
              <InputLabel id="demo-simple-select-label">Vendor</InputLabel>
 
              <Controller
                render={(props) => (
                  <Select value={props.value} onChange={props.onChange}>
                    {vendorList.map((v, i) => (
                      <MenuItem key={i} value={v.id}>
                        {capitalizeFirstLetter(v.vendor_name)}
                      </MenuItem>
                    ))}
                  </Select>
                )}
                name="vendor_id"
                control={control}
                // defaultValue=""
                rules={{
                  required: "Please select vendor",
                }}
              />
              {/* <FormHelperText>{errors.vendor_id?.message}</FormHelperText> */}
              {/* </FormControl> */}
              {/* <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label-vendor">
                Vendor
              </InputLabel>
              <Select
                labelId="demo-simple-select-label-vendor"
                id="demo-simple-select-vendor"
                value={formData?.vendor}
                label="Vendor"
                name="vendor"
                onChange={handleChange}
              >
                {vendorList.map((v, i) => (
                  <MenuItem key={i} value={v.id}>
                    {capitalizeFirstLetter(v.vendor_name)}
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}
              {/* <TextField margin="dense" name='vendor_id' fullWidth value={newPurchaseData.vendor_id}
                            onChange={changeNewPurchaseData} label="Vendor Id" type="number" variant="outlined"
                        /> */}
            </Grid>
            <Grid item xs={12}>
              <TextField
                name="address"
                label="Address"
                fullWidth
                multiline
                minRows={2}
                value={formData.address}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button onClick={handleSave} variant="contained">
            {editMode ? "Update" : "Save"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openSiteContact}
        onClose={() => setOpenSiteContact(false)}
        fullWidth
        maxWidth="md"
      >
        <form onSubmit={(e) => onSubmit(e)}>
          <DialogTitle>{"Add Contacts"}</DialogTitle>
          <DialogContent>
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={12} sm={6}>
                <TextField
                  type="text"
                  name="site_name"
                  label="Site Name"
                  fullWidth
                  value={contactData.site_name}
                  onChange={handleContactChange}
                  disabled
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  name="site_contact_name"
                  label="Site Contact Name"
                  type="text"
                  fullWidth
                  value={contactData.site_contact_name}
                  required
                  onChange={handleContactChange}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  name="phone_no"
                  label="Phone"
                  type="text"
                  fullWidth
                  value={contactData.phone_no}
                  required
                  onChange={handleContactChange}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  name="email"
                  label="Email"
                  type="email"
                  fullWidth
                  value={contactData.email}
                  required
                  onChange={handleContactChange}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  name="address"
                  label="Address"
                  type="text"
                  fullWidth
                  multiline
                  minRows={2}
                  value={contactData.address}
                  required
                  onChange={handleContactChange}
                />
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions>
            <Button type="button" onClick={() => setOpenSiteContact(false)}>
              Cancel
            </Button>
            <Button type="submit" variant="contained">
              Add
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}
